import {
  Button,
  DynamicTopPanel,
  Form,
  SubmitButton,
  Tab,
  Tabs,
} from '../../../components';
import { AgentPage as AgentFormTab } from './AgentFormTab';
import type { AgentProps } from './AgentFormTab';
import { useRouteMatch } from 'react-router';
import { usePermissionAllowed } from '../../../hooks';
import { Intents } from '../Intents';
import { PERMISSIONS } from '../../../shared/constants/permissions';
import {
  CorporateAgentSettings,
  SmartActionsFormInputs,
  PromptsTab,
} from '../../../components/AgentForm/components';

export type AgentTabsProps = AgentProps & {
  knowledgeData: OptionType[];
  activeTab: string;
  setActiveTab: (tab: string) => void;
};

export const AgentTabs: React.FC<AgentTabsProps> = ({
  agent,
  form,
  loading,
  onSubmit,
  onChange,
  editing,
  formId,
  activeTab,
  setActiveTab,
  ...rest
}) => {
  const { params } = useRouteMatch<{ organization_id: string }>();
  const editDisabled = !usePermissionAllowed([PERMISSIONS.EDIT_AGENTS]);

  return (
    <div>
      <Form
        key={String(formId || 'NEW')}
        initialValue={form}
        onChange={onChange}
      >
        <Tabs
          tabs={[
            { name: 'agentSettings', label: 'Agent Settings' },
            { name: 'smartAtions', label: 'Smart Actions' },
            { name: 'corporateSettings', label: 'Corporate Agent Settings' },
            { name: 'prompts', label: 'Prompts' },
          ]}
          tabsClassName="w-fit text-secondary border-b border-gray-200"
          contentClassName="mt-md"
          activeTab={activeTab}
          onChange={setActiveTab}
        >
          <Tab name="agentSettings">
            <AgentFormTab
              {...rest}
              onSubmit={onSubmit}
              onChange={onChange}
              agent={agent}
              form={form!}
              loading={loading}
              editing={editing}
              editDisabled={editDisabled}
            />
          </Tab>
          <Tab name="smartAtions">
            <SmartActionsFormInputs
              form={form!}
              disabled={editDisabled}
              knowledgeData={rest?.knowledgeData}
            >
              <Intents agentId={agent?.id!} disabled={editDisabled} />
            </SmartActionsFormInputs>
          </Tab>
          <Tab name="corporateSettings">
            <CorporateAgentSettings form={form!} disabled={editDisabled} />
          </Tab>
          <Tab name="prompts">
            <PromptsTab agentId={agent?.id!} disabled={editDisabled} />
          </Tab>
        </Tabs>
        {!editDisabled && (
          <div>
            <DynamicTopPanel>
              <div className="flex flex-row gap-x-md justify-center items-center">
                <Button
                  label="Cancel"
                  url={`/agents/${params.organization_id}`}
                  type="contrast"
                  size="medium"
                />
                <SubmitButton
                  label="Save"
                  size="medium"
                  type="primary"
                  loading={editing}
                  disabled={editing}
                  onClick={onSubmit}
                />
              </div>
            </DynamicTopPanel>
          </div>
        )}
      </Form>
    </div>
  );
};
